import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiGift, FiTrendingUp, FiCheckCircle, FiExternalLink } from 'react-icons/fi';
import { trackAffiliateClick } from '../services/api';
import './HeroCard.css';

const HeroCard = ({ casino, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getBonusTypeLabel = (type) => {
    const labels = {
      welcome: 'Welcome Bonus',
      deposit: 'Deposit Bonus',
      freespins: 'Free Spins',
      cashback: 'Cashback',
      nodeposit: 'No Deposit'
    };
    return labels[type] || type;
  };

  const logoContent = casino.logo ? (
    <img src={casino.logo} alt={casino.name} />
  ) : (
    <div className="logo-placeholder">🎰</div>
  );

  return (
    <motion.div
      className="hero-card"
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <div className="hero-card-content">
        {/* Left Side - Casino Info */}
        <div className="hero-left">
          {/* Logo links to the offer's own shareable page */}
          {casino.detailUrl ? (
            <a
              className="hero-logo hero-logo-link"
              href={casino.detailUrl}
              title={`${casino.name} – Angebotsseite öffnen`}
              onClick={(e) => e.stopPropagation()}
            >
              {logoContent}
            </a>
          ) : (
            <div className="hero-logo">{logoContent}</div>
          )}
          <div className="hero-info">
            <h2 className="hero-casino-name">{casino.name}</h2>
            {casino.description && (
              <p className="hero-description">{casino.description}</p>
            )}
            {casino.features && casino.features.length > 0 && (
              <div className="hero-features">
                {casino.features.slice(0, 4).map((feature, index) => (
                  <motion.div
                    key={index}
                    className="hero-feature"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 + index * 0.1 }}
                  >
                    <FiCheckCircle className="check-icon" />
                    <span>{feature}</span>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Right Side - Bonus Info */}
        <div className="hero-right">
          <motion.div
            className="hero-bonus-container"
            animate={{ scale: isHovered ? 1.05 : 1 }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            <div className="hero-bonus-grid">
              <div className="hero-bonus-stat">
                <div className="hero-stat-value">{casino.bonusPercentage || 100}%</div>
                <div className="hero-stat-label">{casino.bonusStickyType?.toUpperCase() || 'WAGERFREE'}</div>
              </div>
              <div className="hero-bonus-stat">
                <div className="hero-stat-value">{casino.maxBonus || 1000}€</div>
                <div className="hero-stat-label">MAX BONUS</div>
              </div>
              <div className="hero-bonus-stat">
                <div className="hero-stat-value">{casino.wageringRequirement || 0}x</div>
                <div className="hero-stat-label">WAGER ({casino.wagerType || 'D'})</div>
              </div>
              <div className="hero-bonus-stat">
                <div className="hero-stat-value">{casino.maxBet || 5}€</div>
                <div className="hero-stat-label">MAXBET</div>
              </div>
            </div>
          </motion.div>

          {/* Terms */}
          <div className="hero-terms">
            {casino.minDeposit && (
              <div className="hero-term">
                Min. Deposit: ${casino.minDeposit}
              </div>
            )}
            {casino.validDays && (
              <div className="hero-term">
                Valid for: {casino.validDays} days
              </div>
            )}
          </div>

          {/* CTA Buttons */}
          <div className="hero-buttons">
            <motion.a
              href={casino.affiliateLink || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-cta-primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={(e) => {
                e.stopPropagation();
                trackAffiliateClick(casino.id);
              }}
            >
              Claim Bonus Now
              <FiExternalLink />
            </motion.a>
            <motion.button
              className="hero-cta-secondary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onClick}
            >
              View Details
            </motion.button>
          </div>

          <div className="hero-legal">
            <small>18+ | T&Cs apply</small>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default HeroCard;
